import { useContext } from 'react'

import { type AudioProgressContext, audioProgressContext } from '../providers/AudioProgressProvider'

export const useAudioProgress = (): AudioProgressContext => useContext(audioProgressContext)
